import React, { useState, useCallback } from "react";
import Autocomplete from "@insightfulscience/atomic-react/Autocomplete";
import AutocompleteLoader from "@insightfulscience/atomic-react/Autocomplete/Loader";
import AutocompleteField from "@insightfulscience/atomic-react/Autocomplete/Field";
import AutocompleteDropdown from "@insightfulscience/atomic-react/Autocomplete/Dropdown";
import ResultItem from "./ResultItem";
import useSearchPlasmid from "./useSearchPlasmid";

const BlockAutocomplete = () => {
	const [input, setInput] = useState("");
	const { isLoading, isAnyMatch, plasmid } = useSearchPlasmid(input.trim());

	const resetInput = useCallback(
		() => setInput(""), //
		[],
	);

	const handleInput = useCallback(
		({ target }) => setInput(target.value), //
		[],
	);

	return (
		<Autocomplete>
			<AutocompleteField
				iconName="search"
				placeholder="Search Plasmids"
				onChange={handleInput}
				value={input}
			/>
			<AutocompleteDropdown display={input.length > 0}>
				{isLoading ? (
					<AutocompleteLoader />
				) : isAnyMatch ? (
					plasmid.map(({ sequences, setData }) => (
						<ResultItem
							key={setData.plasmidSetName}
							sequences={sequences}
							setData={setData}
							onItemSelected={resetInput}
						/>
					))
				) : (
					<span>No matches</span>
				)}
			</AutocompleteDropdown>
		</Autocomplete>
	);
};

export default BlockAutocomplete;
